/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {FETCH_VITALSOURCE_PUBLISH_SUCCESS, FETCH_VITALSOURCE_BOOK_SUCCESS, FETCH_VITALSOURCE_COLLECTION_SUCCESS, UPDATE_VITALSOURCE_SUBSCRIPTION_LENGTH, UPDATE_VITALSOURCE_BOOK_AVAILABILITY } from "../_actions/vitalsource.publish.action";
import moment from "moment/moment";



export const INITIAL_STATE = {
    VITALSOURCE_BOOK_INITIALIZED: 'PENDING',
    BOOKBUILD_STATUS: 'PENDING',
    VITALSOURCE_ACKNOWLEDGEMENT: 'PENDING',
    COMP_CODE_GENERATION :'PENDING',
    INVITE_EMAIL: 'PENDING',
    CALL_BACK_STATUS: 'PENDING',
    subscriptionLength: 180,
    isBookReadyInStore: false

};

export function vitalsourceStatusReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_VITALSOURCE_PUBLISH_SUCCESS: {
            const newObj = {...state};
            action.payload.map(status => {newObj[status.taskType] = status.status + " " + moment(status.createdDate).format("MMM Do YYYY hh:mm:ss Z");});
            return newObj;
        }
        case FETCH_VITALSOURCE_BOOK_SUCCESS: {
            const newObj = {...state};
            newObj["BOOKBUILD_STATUS"] = (action.payload && action.payload.vbBuildStatus) ? action.payload.vbBuildStatus : "PENDING";
            newObj["subscriptionLength"] = (action.payload && action.payload.subscriptionLength) ? parseInt(action.payload.subscriptionLength) : 180;
            newObj["STUDENT_LINK"] = (action.payload && action.payload.studentInviteLink) ? action.payload.studentInviteLink : "Pending Set-up";
            newObj["CALL_BACK_STATUS"] = (action.payload && action.payload.callBackStatus) ? action.payload.callBackStatus : "PENDING";
            return newObj;
        }

        case UPDATE_VITALSOURCE_SUBSCRIPTION_LENGTH: {
            const newObj = {...state};
            newObj["subscriptionLength"] = parseInt(action.payload);
            return newObj;

        }
        case UPDATE_VITALSOURCE_BOOK_AVAILABILITY: {
            const newObj = {...state};
            newObj["isBookReadyInStore"] = action.payload === 200 ? true : false;
            return newObj;

        }
        case FETCH_VITALSOURCE_COLLECTION_SUCCESS: {
            const newObj = {...state};
            newObj["subscriptionLength"] = (action.payload && action.payload.subscriptionLength) ? parseInt(action.payload.subscriptionLength) : 180;
            return newObj;
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/vitalsource.status.reducer.js